export const AVERAGE = 'AVERAGE'
export const UP_TO = 'UP_TO'
